<div id="products" class="page-layout carded fullwidth" fusePerfectScrollbar>

  <!-- TOP BACKGROUND -->
  <div class="top-bg mat-accent-bg"></div>
  <!-- / TOP BACKGROUND -->

  <!-- CENTER -->
  <div class="center">

    <!-- HEADER -->
    <div class="header white-fg"
      fxLayout="column" fxLayoutAlign="center center"
      fxLayout.gt-xs="row" fxLayoutAlign.gt-xs="space-between center">

      <!-- APP TITLE -->
      <div class="logo my-12 m-sm-0"
        fxLayout="row" fxLayoutAlign="start center">
        <mat-icon class="logo-icon mr-16" *fuseIfOnDom >place</mat-icon>
        <span class="logo-text h1" *fuseIfOnDom >{{'main.learningCategory' | translate}}</span>
      </div>
      <!-- / APP TITLE -->

      <!-- SEARCH -->
      <!--      <div class="search-input-wrapper mx-12 m-md-0 width-5-10"-->
      <!--           fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">-->
      <!--        <label for="search" class="mr-8">-->
      <!--          <mat-icon class="secondary-text">search</mat-icon>-->
    <!--        </label>-->
    <!--        <mat-form-field floatLabel="never" fxFlex="1 0 auto">-->
    <!--          <input id="search" matInput #filter placeholder="{{'main.search' | translate}}">-->
  <!--        </mat-form-field>-->
<!--      </div>-->
<!-- / SEARCH -->

<button mat-raised-button
  (click)="newCategory()"
  class="add-product-button mat-white-bg my-12 mt-sm-0">
  <span>{{'add' | translate}}</span>
</button>

</div>
<!-- / HEADER -->
<!-- CONTENT CARD -->
<div class="content-card mat-white-bg">

  <mat-table class="products-table"
    #table [dataSource]="learnCategories"
    matSort
    [@animateStagger]="{value:'50'}"
    fusePerfectScrollbar>


    <!-- Name Column -->
    <ng-container cdkColumnDef="name">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'canton.name' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let lc">
        <p class="text-truncate">{{lc.name}}</p>
      </mat-cell>
    </ng-container>
    <!-- Image Column -->
    <ng-container cdkColumnDef="color">
      <mat-header-cell *cdkHeaderCellDef mat-sort-header>{{'eventType.color' | translate}}</mat-header-cell>
      <mat-cell *cdkCellDef="let lc">
        <div class="type-color" [ngStyle]="{'background-color': lc.color}"></div>
      </mat-cell>
    </ng-container>


    <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>

    <mat-row *cdkRowDef="let lc; columns: displayedColumns;"
      class="product"
      matRipple
      (click)="editCategory(lc)">
    </mat-row>

  </mat-table>
  @if (learnCategories.length === 0) {
    <div class="no-data-msg">
      <span class="mat-headline-6">{{'main.noData' | translate}}</span>
    </div>
  }
  <!--      <mat-paginator #paginator-->
  <!--                     [length]="organizationTypes.filteredData.length"-->
  <!--                     [pageIndex]="0"-->
  <!--                     [pageSize]="50"-->
  <!--                     [pageSizeOptions]="[25, 50, 100]">-->
<!--      </mat-paginator>-->

</div>
<!-- / CONTENT CARD -->
</div>
<!-- / CENTER -->
</div>
